import { useEventHub } from '@pwc/event-hub-ui';
import { DateTime } from 'luxon';

export const useFormatDateI18n = (date: string): string => {
  const { eventHub } = useEventHub();
  const currentLang = eventHub?.getCurrentLang();
  /* 
  Luxon parse to 'jp' doesn't show the kanji as shown in this issue: https://github.com/moment/luxon/issues/549#issuecomment-563900490
  Workaround is to show Traditional Hong Kong locale instead as they have the same 12月 format.
*/
  const LUXON_JAPANESE_LOCALE_WORKAROUND = 'zh';

  const formattedDate: string = DateTime.fromISO(date, {
    zone: 'utc',
  })
    .setLocale(currentLang === 'jp' ? LUXON_JAPANESE_LOCALE_WORKAROUND : 'en')
    .toLocal()
    .toFormat('H:mm ZZZZ - d LLL yyyy');

  return formattedDate;
};
